module.exports = __webpack_public_path__ + "static/media/zuk_farm.141ccb3d.webp";